import script from "./EmailVerify.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailVerify.vue?vue&type=script&setup=true&lang=js"

import "./EmailVerify.vue?vue&type=style&index=0&id=236ef0e6&lang=scss"

const __exports__ = script;

export default __exports__